import { render } from "./ModalDocumentSign.vue?vue&type=template&id=3caaeab6&scoped=true"
import script from "./ModalDocumentSign.vue?vue&type=script&lang=js"
export * from "./ModalDocumentSign.vue?vue&type=script&lang=js"

import "./ModalDocumentSign.vue?vue&type=style&index=0&id=3caaeab6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3caaeab6"]])

export default __exports__